// extracted by mini-css-extract-plugin
export default {"mainContainer":"Reupload_mainContainer__KmyHL"};